import React, { Component } from 'react'
import {
  Container, Row, Col, Input, Label, Button, Spinner, Card, CardBody,
  Modal, ModalHeader, ModalBody, ModalFooter, FormGroup,
} from 'reactstrap'
import DataTable from '../../components/Template/Table/DataTable'
import { notifyError, notifySuccess } from '../../utils/notify'
import oikosApi from '../../services/oikos'

export default class Labs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      labs: null,
      users: [],
      name: '',
      link: '',
      desc: '',
      obs: '',
      getLabsIsLoading: false,
      handleSubmitIsLoading: false,
      deleteIsLoading: false,
      addModalIsOpen: false,
      editId: null,
      searchTerm: '',
    }
  }

  componentDidMount() {
    this.fetchLabs()
  }

  fetchLabs = async () => {
    try {
      this.setState({ getLabsIsLoading: true })
      const pars = {
        table: 'labs',
        action: 'get',
        'fields[(SELECT pf.pf_nome FROM pf WHERE pf.pf_id = labs.labs_usuarioCria)]': 'userName'
      }
      const res = await oikosApi.get('/', pars)
      
      this.setState({
        getLabsIsLoading: false,
        labs: Array.isArray(res.data) ? res.data.filter(l => Number(l.labs_ativo) === 1) : [],
      })
    } catch (e) {
      notifyError('Erro ao carregar labs.', e.toString())
      this.setState({ getLabsIsLoading: false })
    }
  }

  toggleModal = (lab = null) => {
    if (lab && lab.labs_id) {
      this.setState(prevState => ({
        addModalIsOpen: !prevState.addModalIsOpen,
        editId: lab.labs_id,
        name: lab.labs_nome || '',
        link: lab.labs_link || '',
        desc: lab.labs_descricao || '',
        obs: lab.labs_observacoes || '',
      }))
    } else {
      this.setState(prevState => ({
        addModalIsOpen: !prevState.addModalIsOpen,
        editId: null,
        name: '',
        link: '',
        desc: '',
        obs: '',
      }))
    }
  }

  handleSubmit = async () => {
    const { name, link, desc, obs, editId } = this.state
    const { user } = this.props
    const userId = user ? user.pf_id : 1

    if (!name || !name.trim()) {
      notifyError('O campo Nome é obrigatório.')
      return
    }

    try {
      this.setState({ handleSubmitIsLoading: true })
      
      const payloadData = {
        labs_nome: name.trim(),
        labs_link: link.trim() || null,
        labs_descricao: desc.trim() || null,
        labs_observacoes: obs.trim() || null,
      }

      if (!editId) {
        payloadData.labs_usuarioCria = userId;
        payloadData.labs_usuarioMod = userId;
      } else {
        payloadData.labs_usuarioMod = userId;
      }

      const item = {
        table: 'labs',
        action: editId ? 'update' : 'insert',
        data: payloadData,
      }

      if (editId) {
        item.data.labs_id = editId
      }

      console.log('--- ENVIANDO REQUEST DE SAVE ---')
      console.log('Payload:', item)

      const res = await oikosApi.post('/', item)
      
      console.log('--- RESPOSTA DE SAVE ---')
      console.log('Status HTTP:', res.status)
      console.log('Dados da Resposta:', res.data)

      notifySuccess(editId ? 'Link atualizado.' : 'Link adicionado.')
      this.setState({ handleSubmitIsLoading: false, addModalIsOpen: false, editId: null })
      this.fetchLabs()
    } catch (e) {
      console.error('--- ERRO DE SAVE ---')
      console.error('Payload tentado:', {
        table: 'labs',
        action: editId ? 'update' : 'insert',
        data: {
          labs_nome: name.trim(),
          labs_link: link.trim() || null,
          labs_descricao: desc.trim() || null,
          labs_observacoes: obs.trim() || null,
          ...(editId ? { labs_id: editId } : {})
        }
      })
      console.error('Erro Capturado:', e.response ? e.response.data : e)
      
      const errorMsg = e.response && e.response.data ? JSON.stringify(e.response.data) : e.toString()
      notifyError(editId ? 'Erro ao atualizar link.' : 'Erro ao adicionar link.', errorMsg)
      this.setState({ handleSubmitIsLoading: false })
    }
  }

  deleteLab = async (labId) => {
    try {
      this.setState({ deleteIsLoading: true })
      const pars = {
        table: 'labs',
        action: 'update',
        data: {
          labs_id: labId,
          labs_ativo: 0
        }
      }
      
      console.log('--- ENVIANDO REQUEST DE DELETE ---')
      console.log('Payload:', pars)
      
      const res = await oikosApi.post('/', pars)
      
      console.log('--- RESPOSTA DE DELETE ---')
      console.log('Status HTTP:', res.status)
      console.log('Dados da Resposta:', res.data)

      notifySuccess('Link removido.')
      this.setState({ deleteIsLoading: false })
      this.fetchLabs()
    } catch (e) {
      console.error('--- ERRO NO DELETE ---')
      console.error('Erro Capturado:', e.response ? e.response.data : e)
      
      notifyError('Erro ao remover link.', e.response && e.response.data ? JSON.stringify(e.response.data) : e.toString())
      this.setState({ deleteIsLoading: false })
    }
  }

  render() {
    const {
      labs,
      name,
      link,
      desc,
      obs,
      getLabsIsLoading,
      handleSubmitIsLoading,
      addModalIsOpen,
      editId,
      searchTerm,
    } = this.state

    const filtered = labs
      ? labs.filter(l =>
          !searchTerm ||
          (l.labs_nome || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
          (l.labs_link || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
          (l.labs_descricao || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
          (l.labs_observacoes || '').toLowerCase().includes(searchTerm.toLowerCase())
        )
      : []

    return (
      <div>
        {/* Modal de adicionar / editar */}
        <Modal centered isOpen={addModalIsOpen} toggle={() => this.toggleModal()}>
          <ModalHeader toggle={() => this.toggleModal()}>{editId ? 'Editar Link' : 'Adicionar'}</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Nome <span style={{ color: 'red' }}>*</span></Label>
              <Input
                type="text"
                value={name}
                placeholder="Nome do lab"
                onChange={e => this.setState({ name: e.target.value })}
              />
            </FormGroup>
            <FormGroup>
              <Label>Link</Label>
              <Input
                type="url"
                value={link}
                placeholder="https://..."
                onChange={e => this.setState({ link: e.target.value })}
              />
            </FormGroup>
            <FormGroup>
              <Label>Descrição</Label>
              <Input
                type="textarea"
                rows="2"
                value={desc}
                placeholder="Descrição do link..."
                onChange={e => this.setState({ desc: e.target.value })}
              />
            </FormGroup>
            <FormGroup>
              <Label>Observações</Label>
              <Input
                type="textarea"
                rows="3"
                value={obs}
                placeholder="Observações adicionais..."
                onChange={e => this.setState({ obs: e.target.value })}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={() => this.toggleModal()}>
              Cancelar
            </Button>
            <Button
              color="primary"
              onClick={this.handleSubmit}
              disabled={handleSubmitIsLoading}
            >
              Salvar
              {handleSubmitIsLoading && <Spinner size="sm" className="ml-2" />}
            </Button>
          </ModalFooter>
        </Modal>

        <Container fluid>
          <Row className="mb-2">
            <Col>
              <h4>Lista de Links</h4>
            </Col>
            <Col style={{ textAlign: 'right' }}>
              <Button color="primary" type="button" onClick={() => this.toggleModal()}>
                Adicionar
              </Button>
            </Col>
          </Row>

          {/* Busca */}
          <Row className="mb-3">
            <Col md={4}>
              <Input
                type="text"
                placeholder="Buscar por nome ou link..."
                value={searchTerm}
                onChange={e => this.setState({ searchTerm: e.target.value })}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <CardBody>
                  {getLabsIsLoading && (
                    <Row>
                      <Col className="d-flex align-items-center justify-content-center py-3">
                        <Spinner size="sm" />
                      </Col>
                    </Row>
                  )}

                  {!getLabsIsLoading && labs !== null && (
                    <DataTable
                      data={{
                        columns: [
                          {
                            label: 'ID',
                            field: 'id',
                            sort: 'asc',
                          },
                          {
                            label: 'Nome',
                            field: 'name',
                            sort: 'asc',
                          },
                          {
                            label: 'Descrição',
                            field: 'desc',
                            sort: 'disabled',
                            width: 250,
                          },
                          {
                            label: 'Link',
                            field: 'link',
                            sort: 'disabled',
                            width: 150,
                          },
                          {
                            label: 'Usuário',
                            field: 'user',
                            sort: 'asc',
                          },
                          {
                            label: 'Observações',
                            field: 'obs',
                            sort: 'disabled',
                          },
                          {
                            label: 'Ações',
                            field: 'actions',
                            sort: 'disabled',
                          },
                        ],
                        rows: filtered.map(row => {
                          return {
                            id: row.labs_id,
                            name: row.labs_nome,
                            desc: row.labs_descricao ? (
                              <div style={{ overflowWrap: 'break-word', wordBreak: 'break-word', whiteSpace: 'pre-wrap', maxWidth: '250px', maxHeight: '100px', overflowY: 'auto', paddingRight: '5px' }}>
                                {row.labs_descricao}
                              </div>
                            ) : '—',
                            link: row.labs_link
                              ? (
                                <div style={{ maxWidth: '200px', maxHeight: '100px', overflowY: 'auto', overflowWrap: 'break-word', wordBreak: 'break-word' }}>
                                  <a href={row.labs_link} target="_blank" rel="noopener noreferrer">
                                    {row.labs_link}
                                  </a>
                                </div>
                              )
                              : '—',
                            user: row.userName || 'Desconhecido',
                            obs: row.labs_observacoes ? (
                              <div style={{ overflowWrap: 'break-word', wordBreak: 'break-word', whiteSpace: 'pre-wrap', maxWidth: '250px', maxHeight: '100px', overflowY: 'auto', paddingRight: '5px' }}>
                                {row.labs_observacoes}
                              </div>
                            ) : '—',
                            actions: (
                            <div>
                              <Button
                                size="sm"
                                color="light"
                                title="Editar"
                                onClick={() => this.toggleModal(row)}
                              >
                                <i className="ri-pencil-line" />
                              </Button>
                              <Button
                                size="sm"
                                color="light"
                                className="ml-2"
                                title="Remover"
                                onClick={() => this.deleteLab(row.labs_id)}
                              >
                                <i className="ri-delete-bin-6-line" />
                              </Button>
                            </div>
                          ),
                        };
                        }),
                      }}
                    />
                  )}

                  {!getLabsIsLoading && labs !== null && filtered.length === 0 && (
                    <p className="text-muted text-center mt-3">Nenhum link encontrado.</p>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}
